<template>
  <svg class="accordion-icon" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path v-if="top" d="M1.6665 5L3.99984 3L6.33317 5" stroke-linecap="round"/>
    <path v-if="bottom" d="M1.6665 3L3.99984 5L6.33317 3" stroke-linecap="round"/>
  </svg>
</template>

<script>
export default {
  name: 'PanoramaAccordionIcon',
  props: {
    top: {
      type: Boolean,
      default: false
    },
    bottom: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.accordion-icon {
  stroke: var(--panorama-text-color);
  width: 16px;
  height: 16px;
}

@media screen and (min-width: 768px) {
  .accordion-icon {
    width: 8px;
    height: 8px;
  }
}

@media screen and (min-width: 1920px) {
  .accordion-icon {
    width: 0.45vw;
    height: 0.45vw;
  }
}
</style>
